import { BehaviorSubject, Observable, of } from 'rxjs';
import { MaintenanceOrderResponse } from '../models/maintenance-order-response.model';
import { Injectable } from '@angular/core';
import { Equipment } from '../models/equipment.model';
import { ShopRepairCostAllocation } from '../models/shop-repair-cost-allocation.model';
import { WorkOrderFilterFilterFormValue } from '../models/maintenance-order-filter.model';
import { LabourRatesFilter } from '../models/labour-rates-filter.model';
import { MaterialRateFilterForm } from '../form-model/material-rate-filter.form.model';
import { ShopManagementFilterForm } from '../form-model/shop-management-filter.form.model';
import { ShopManagementFilterFormValue } from '../models/shop-management-filter.model';
@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  private workOrder$ = new BehaviorSubject<MaintenanceOrderResponse | null>(null);
  setWorkOrder(workOrder: MaintenanceOrderResponse | null) {
    this.workOrder$.next(workOrder);
  }
  getWorkOrder(): Observable<MaintenanceOrderResponse | null> {
    return this.workOrder$.asObservable();
  }

  private equipment$ = new BehaviorSubject<Equipment | null>(null);
  setEquipment(equipment: Equipment | null) {
    this.equipment$.next(equipment);
  }
  getEquipment(): Observable<Equipment | null> {
    return this.equipment$.asObservable();
  }

  private pastRepairs$ = new BehaviorSubject<string[]>([]);
  setPastRepairs(pastRepairs: string[]) {
    this.pastRepairs$.next(pastRepairs);
  }
  getPastRepairs(): Observable<string[]> {
    return this.pastRepairs$.asObservable();
  }

  private workOrderFilterFormValue: WorkOrderFilterFilterFormValue | null = null;
  setWorkOrderFilterFormValue(value: WorkOrderFilterFilterFormValue | null) {
    this.workOrderFilterFormValue = value;
  }
  getWorkOrderFilterFormValue(): WorkOrderFilterFilterFormValue | null {
    return this.workOrderFilterFormValue;
  }

  private labourRatesFilterFormValue: LabourRatesFilter | null = null;
  setLabourRatesFilterFormValue(value: LabourRatesFilter | null) {
    this.labourRatesFilterFormValue = value;
  }
  getLabourRatesFilterFormValue(): LabourRatesFilter | null {
    return this.labourRatesFilterFormValue;
  }

  private materialRateFilterFormValue: MaterialRateFilterForm | null = null;
  setMaterialRateFilterFormValue(value: any | null) {
    this.materialRateFilterFormValue = value;
  }
  getMaterialRateFilterFormValue(): MaterialRateFilterForm | null {
    return this.materialRateFilterFormValue;
  }
  private shopManagementFilterFormValue: ShopManagementFilterFormValue | null = null;
  setShopManagementFilterFormValue(value: any | null) {
    this.shopManagementFilterFormValue = value;
  }
  getShopManagementFilterFormValue(): ShopManagementFilterFormValue | null {
    return this.shopManagementFilterFormValue;
  }
}
